<template>
  <div v-if="tickets && tickets.length > 0" class="row">
    <div class="col-md-12">
      <div class="card hg-topline" :style="topLineOverride">

        <terms :event="event"></terms>

        <div class="card-body" align="center">
          <div class="" style="margin-bottom:20px">

            <button v-if="!readonly && !submitted" class="btn btn-primary btn-lg" :style="{'background-color': event.buttoncolour, 'border-color': event.buttoncolour}" :disabled="termsAccepted == false || submitted || expired" @click="completePage" type="button">Book Tickets</button>
            <button v-else-if="!readonly && submitted" class="btn btn-secondary btn-lg" type="button">
              <i class='fa fa-spinner fa-spin'></i> Please Wait</button>
            <button v-else-if="readonly && !submitted" class="btn btn-primary btn-lg" :style="{'background-color': event.buttoncolour, 'border-color': event.buttoncolour}" @click="completePage" type="button">Update Details</button>
            <button v-else-if="readonly && submitted" class="btn btn-secondary btn-lg" type="button">
              <i class='fa fa-spinner fa-spin'></i> Please Wait</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import terms from "./terms.vue";
import EventBus from "../../events/event-bus";
import bookingMixin from "../common/booking-mixin";
import ticketMixins from "./tickets-mixin";
import {mapGetters} from 'vuex';
import _ from 'lodash'

export default {
  mixins: [bookingMixin, ticketMixins],

  components: {
    terms: terms
  },

  data: function() {
    return {
      tickets: null,
      event: null,
      termsAccepted: false,
      submitted: false,
      expired: this.$store.getters.getExpired,
      readonly: this.$store.getters.getReadOnly,
      eventBooking: this.$store.getters.getEventBooking,
      mode: null
    };
  },

  created() {
    var self = this;
    EventBus.$on("selectTerms", function(termsValue) {
      self.termsAccepted = termsValue;
    });

    this.tickets = this.$store.getters.getSelectedTickets;
    this.event = this.$store.getters.getEvent;

    this.$store.subscribe((mutation, state) => {
      if (mutation.type == "setSelectedTickets") {
        self.tickets = mutation.payload;
      }
    });

    var urlParams = new URLSearchParams(window.location.search);
    var modeParam = urlParams.get('mode');
    this.mode = modeParam;
  },

  computed: {
    ...mapGetters({
      hasPaidTickets: 'getChargeable'
    }),
    topLineOverride() {
      return { borderTop: "4px solid " + this.event.phcolour };
    }
  },

  methods: {

    totalCost(){
      var earlyBird = this.earlyBirdValid;
      var total = 0;
      this.tickets.forEach(function(ticket) {
        if(earlyBird){
          total += parseFloat(ticket.cost_a);
        } else {
          total += parseFloat(ticket.cost_b);
        }
      });
      return total;
    },

    completePage: _.debounce(function() {

      // if total tickets cost is zero set chargeable to false
      var totalTicketCost = this.totalCost(       );
      if(totalTicketCost === 0){
        this.$store.commit("setChargeable", false);
      } else {
        this.$store.commit("setChargeable", true);
      }

      // if you click quick enough you could call this method twice before submitted disables the button
      // hence a further check here
      if (this.submitted)
      {return}
      var self = this;

      this.submitted = true;

      // Calls validation callback and deals with the promise
      this.$parent.$children[2].saveBookingDetails().then(result => {
        if (result) {
          if (self.$parent.$children[1].completeSelections() == true) {
            if (self.event.show_add_attendees) {
              self.$parent.$router.push({ name: "userdetails" });
            } else {
              if (self.hasPaidTickets && !self.readonly) {
                self.completeBooking(null, null, null);
                //self.$parent.$router.push({ name: "payment" });
              } else {
                if (self.readonly) {
                  self.updateBooking(this.mode);
                } else {
                  self.completeBooking(null, null, null, true);
                }
              }
            }
          } else {
            self.submitted = false;
          }
          return;
        } else {
          self.submitted = false;
          self.$notify.error({
            message: "Fix validation errors",
            title: "Booking Form"
          });
        }
      });
    }, 300)
  }
};
</script>
